import { EmeraldIcon } from "@emerald-react/icon";
import { EmeraldTooltip } from "@emerald-react/tooltip";

const MapRestore = (props: { onRestoreChange: (e: any) => void }) => {
    const { onRestoreChange } = props;

    return (
        <EmeraldTooltip
            placement="right"
            triggerElement={
                <EmeraldIcon
                    icon="history"
                    type="outlined"
                    variant="icon"
                    onClick={onRestoreChange}
                    className="absolute rounded-sm bg-white z-1 p-[2.5px] cursor-pointer text-map-icon border-2 border-map-light"
                />
            }
        >
            Reset pins to original coordinates.
        </EmeraldTooltip>
    );
};

export default MapRestore;
